import { render, staticRenderFns } from "./InfoPoint.vue?vue&type=template&id=d6452774&scoped=true"
import script from "./InfoPoint.vue?vue&type=script&lang=ts"
export * from "./InfoPoint.vue?vue&type=script&lang=ts"
import style0 from "./InfoPoint.vue?vue&type=style&index=0&id=d6452774&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6452774",
  null
  
)

export default component.exports